import { createResource } from 'redux-rest-resource';
import {
  HEADERS as headers,
  CAMPAIGNS_URL,
} from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'campaign',
  url: `${CAMPAIGNS_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
